import React, { Component } from 'react';
import { connect } from 'react-redux';
import isWebview from '@gerenciatd/next13.utils.common.is-webview';
import getCookie from '@gerenciatd/next13.utils.common.get-cookie';
import setCookie from '@gerenciatd/next13.utils.common.set-cookie';
import { actions as mainActions } from '@/bit/reducers/next13.reducers.main-reducer'
import sendGaPageEvent from '@gerenciatd/next13.utils.metrics.send-ga-page-event'
import {
  getTabId,
  getUserPersistedInfo,
  generatePageId,
  createPageEventObject, extractUserProperties, extractMainProperties,
} from './utils';

const EVENT_TYPES = {
  VIEW: 'view',
  LOADED: 'printed',
}

const getRecom = async (userIdPartyHash) => {
  let recomResponse = null;
    const module = await import(
      "@gerenciatd/next13.adabyron.abs-layer.get-credit"
    );
    const getCredit = module.default;
    recomResponse = await getCredit(userIdPartyHash)
  return recomResponse;
}

class RouteHandler extends Component {
  getContextSeoInfo = () => {
    let contextSeoMeta = '';
    let pageName = '';
    let pageProductName = '';
    try {
      contextSeoMeta = document.querySelector('meta[id="context_seo_meta"]').getAttribute('content');
    } catch(error) {}
    try {
      pageName = document.querySelector('meta[id="page_name"]').getAttribute('content');
    } catch(error) {}
    try {
      pageProductName = document.querySelector('meta[id="product_name"]').getAttribute('content');
    } catch(error) {}

    const res = {
      contextSeoMeta,
      pageName,
      pageProductName,
    }

    return res;
  }

  getReadyGA = () => {
    let ga = getCookie('_ga') || '';
    const gaTokkens = ga.split('.');
    if (gaTokkens.length > 2) {
      ga = gaTokkens.slice(2).join('.');
    }
    return ga;
  }


  getSessId = () => {
    let sessId = getCookie('_mc_sessid');
    if(!sessId){
      sessId = `${new Date().getTime()}`;
      setCookie('_mc_sessid', sessId, undefined, '.movistar.es');
    }
    return sessId
  }

  getOptanonCookieInfo = async () => {
    let optanon = getCookie("OptanonConsent");
    optanon = decodeURIComponent(optanon);
    let ad_storage = optanon && optanon.indexOf("C0004:1") !== -1 ? "granted" : "denied";
    let analytics_storage = optanon && optanon.indexOf("C0002:1") !== -1 ? "granted" : "denied";
    if (isWebview()){
      let retries = 10;
      let waitWB = setInterval(async () => {
        retries--;
        if (window.webviewBridge){
          retries = -1;
          let status = await window.webviewBridge.getAttStatus();
          if (status != null) {
            ({status} = status);
            // cogemos el valorcito, sino me quedo los que ya
            ad_storage = status;
            analytics_storage = status;
          }
        } 
        if (retries<0) {
          clearInterval(waitWB)
        }
      },100)
    }

    return {
      ad_storage,
      analytics_storage,
    }
  }

  sendGaConfig = async ({context, ad_storage, analytics_storage}) => {
   const shouldSendHash = ad_storage === 'granted' && analytics_storage === 'granted';
   const data = createPageEventObject(context);
   // inicializo config
   const mainProperties = extractMainProperties(data);
   const userProperties = extractUserProperties(data, shouldSendHash);

    // zonas
    let zipcode = this.geo && this.geo.zone ? this.geo.zone : "";
    if (zipcode === "ZR") { zipcode = "regulada"; }
    if (zipcode === "ZL") { zipcode = "libre"; }
    if (zipcode === "ZM") { zipcode = "mixta"; }

    const logado = (context && (context.userIdPartyHash || context.userCUCFijoHash || context.userCUCMovilHash || context.userCUCPrepagoHash)) || ""
    
    try {
      gtag("config", `${process.env.NEXT_PUBLIC_GTM_ID}`, {
        "page_variation": logado ? "cliente":"no-cliente",
        transport_url: "https://landings.dev.col.movistar.es",
        first_party_collection: true,
        ...mainProperties,
        ...userProperties,
        "zip-code": zipcode,
      })
  
      gtag('get', 'G-J1GJWFY08P', 'session_id', (sessionId) => {
        context.clientIDs.sessionId = sessionId;
        const {setContextData} = this.props;
        setContextData(context);
      });
    } catch(e){
      console.log(e)
    }

    this.sendPageEvent(context, EVENT_TYPES.LOADED);
  }

  updateConsent = async ({context, callBack}) => {
    let ad_storage = "denied";
    let analytics_storage = "denied";
   ({ ad_storage, analytics_storage } = await this.getOptanonCookieInfo())
    if (ad_storage !== "denied" || analytics_storage !== "denied") {
      try {
        gtag("consent", "update", {
          "ad_storage": ad_storage,
          "analytics_storage": analytics_storage,
        });
      } catch(e) {
        console.log(e)
      }
    }
    callBack({context, ad_storage, analytics_storage});
  }

  sendPageEvent = async (context, eventType) => {
    if (eventType === EVENT_TYPES.VIEW) {
        try {      // Event view, buen punto para el set general de ga
        //1) updateConsent =>> 2) sendGaConfig
        this.updateConsent({context, callBack: this.sendGaConfig});
        } catch(error) {
          console.error(error);
        }
        //3) meantime render app without stops
        const {setContextData} = this.props;
        setContextData(context);
      } else {
        sendGaPageEvent(eventType);
      }
  }

  handleRouteLanding = async (...args) => {   
    const context = await this.createInitialContextObj();
    this.sendPageEvent(context, EVENT_TYPES.VIEW);
    if (`${process.env.NEXT_PUBLIC_ENV_NAME}` !== 'dev') {
      import('@gerenciatd/next13.adabyron.misc.ping-cms').then(pingModule => {
        // ping a cms page
        pingModule = pingModule.default;
        let ping = new pingModule({ context });
        ping.sendPingCmsPage();
      });
    }
  }

  createInitialContextObj = async () => {
    const  { context: ssrContext, checkCPAndSetZones, setCpParams, setUserPqInfo, setUserLgInfo, setUserRecom } = this.props;
    let initialContextData = {}
    let geo = null;
    let userPq = null;
    let userLg = null;
    let userRecom = null;

    const persistedInfo = {...getUserPersistedInfo()};
    let userContextInfo = {}
    if (persistedInfo) {
      // si hay persisted info me lo quedo
      userContextInfo = {...persistedInfo}
        // no tengo info de geo
        if (!userContextInfo.geo && userContextInfo && (!userContextInfo.geo || !userContextInfo.geo.postalCode)) {
          checkCPAndSetZones({cp: ''});
        } else {
          // si tiene geo persistido me lo quedo
          geo = {
            cp: (userContextInfo.geo && userContextInfo.geo.postalCode) || '28030', 
            zone: (userContextInfo.geo && userContextInfo.geo.zone)  || 'ZL', 
            municipio: (userContextInfo.geo && userContextInfo.geo.municipio)  || '', 
            businessZones: (userContextInfo.geo && userContextInfo.geo.businessZones)  || [],
          }
        }
    } else {
      checkCPAndSetZones({cp: ''});
      userContextInfo = {
        userCUCFijoHash: "",
        userCUCMovilHash: "",
        userCUCPrepagoHash: "",
        userIdPartyHash:  "",
        userName:  "",
        userType: "",
      }
    }

    try {
      const pageId = generatePageId();
      window.pageId = pageId;

      initialContextData = {
        ...ssrContext,
        numLocationChanges: 0,
        tabId: getTabId(),
        pageWebCode: null,
        pageName: null,
        pageWebName: null,
        pageProductCode: null,
        pageProductName: null,
        clientIDs: {
          pageId,
          ga: this.getReadyGA(),
          sessId: this.getSessId(),
        },
        userType: '',
        pageSegment: `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`,
        contextURL: window.location.href,
        subseg: false,
        userPriority: false,
        version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || 'unknown',
        ...this.getContextSeoInfo(),
        ...persistedInfo,
        ...userContextInfo,
      };

    // MANDAMOS SUBSCRICIONES A CLIENTE BEGINS
    //  GEO
    if(geo){ setCpParams(geo); }
    //    USER PQ
    if (initialContextData.userPq){
      userPq = initialContextData.userPq;
      const userFlags = initialContextData.userFlags || []
      setUserPqInfo({
        userPq,
        userFlags,
      });
    } else {
      setUserPqInfo({
        userPq: {},
        userFlags: [],
      });
    }
    //    USER LG
    if (initialContextData.userLg){
      userLg = initialContextData.userLg;
      setUserLgInfo({userLg});
    }
    //    USER RECOM
    // Solo si ha aceptado las cookies 
   const { ad_storage, analytics_storage } = await this.getOptanonCookieInfo();
   if(
    ad_storage ==="granted" && analytics_storage === "granted" && 
    initialContextData.userIdPartyHash
    ){
      let newTsUserRecom = 0;
      userRecom = initialContextData.userRecom || null;
      // me quedo lo persistido o nulo si no tengo
      const tsUserRecom = (initialContextData && initialContextData.tsUserRecom) || 0 ;
      const msDay = (1000 * 60 * 60) * 24;
      // Compruebo que el usuario lleve mas de un dia logado para refrescar la recomendacion o dejo la del ts
      const timestampActual = Date.now();
      const diferenciaEnMilisegundos = tsUserRecom !== -1 ? (timestampActual - tsUserRecom) : msDay;
      const diferenciaEnHoras = diferenciaEnMilisegundos / (1000 * 60 * 60);
      let notContent = false;

      // llamamos al api si han pasado 24h o no tengo marca de tiempo, porque los datos pueden ser nulos
      if (diferenciaEnHoras >= 24 || !tsUserRecom) {
        let recomResponse = null;
        try  {
          recomResponse = await getRecom(initialContextData.userIdPartyHash);
          if (recomResponse && recomResponse.userRecom) {
            userRecom = recomResponse.userRecom
          } else {
            notContent = true;
            userRecom = null;
          }
        } catch(e) {
          // si no hay content es lo que hay
          notContent = true;
          userRecom = null;
        }
        if ((userRecom) || notContent) {
          userRecom = userRecom;
          newTsUserRecom = Date.now();
        }
      }


      setUserRecom({userRecom, tsUserRecom: newTsUserRecom})
    } else {
      //no logado o no persmisos
      setUserRecom({userRecom: null, tsUserRecom: 0})
    }
    // ANTES DE ACABAR PASO EL MOCHO Y LIMPIO
    if (initialContextData && initialContextData.geo){
      this.geo = initialContextData.geo
      delete initialContextData.geo;
    }
    if (initialContextData && initialContextData.userPq){
      this.userPq = initialContextData.userPq
      delete initialContextData.userPq;
      delete initialContextData.userFlags
    }  
    if (initialContextData && initialContextData.userLg){
      this.userLg = initialContextData.userLg
      delete initialContextData.userLg;
    } 
    if (initialContextData && initialContextData.userRecom){
      this.userRecom = initialContextData.userRecom
      delete initialContextData.userRecom;
    } 
    // MANDAMOS SUBSCRICIONES A CLIENTE ENDS
    
      
      return initialContextData;
    } catch (error) {
      console.error(error)
      return initialContextData;
    }
  }

  componentDidMount(){  
    // para cada hit setear dyna si corresponde
    window.interceptorFlag = false;
    this.handleRouteLanding();
  }

  render(){
    return <></>
  }
}


const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = (dispatch) => ({
  setCpParams: data => dispatch(mainActions.setCpParams(data)),
  setContextData: newData => dispatch(mainActions.setContextData(newData)),
  checkCPAndSetZones: (data) => dispatch(mainActions.checkCPAndSetZones(data)),
  setUserPqInfo:  (data) => dispatch(mainActions.setUserPqInfo(data)),
  setUserLgInfo: (data) => dispatch(mainActions.setUserLgInfo(data)),
  setUserRecom: (data) => dispatch(mainActions.setUserRecom(data)),
});


export default (connect(mapStateToProps, mapDispatchToProps)(RouteHandler))